"use strict";
var booleanGenerator = require("../generators/boolean");
var booleanType = booleanGenerator;
module.exports = booleanType;



//////////////////
// WEBPACK FOOTER
// ./~/json-schema-faker/lib/types/boolean.js
// module id = 1332
// module chunks = 1